// extracted by mini-css-extract-plugin
export default {"wrapper":"Aktuelles_wrapper__rfckV","head":"Aktuelles_head__go3JT","section":"Aktuelles_section__XeX+k","text":"Aktuelles_text__dKwWU","images":"Aktuelles_images__bmuhT"};